module.exports = __webpack_public_path__ + "static/Chainalysis-372309c7fc834ee855106dd957742366.jpg";